import { PATHS } from "../../constants/paths";
import {
  SFByBusinessCapabilityNavIcon,
  SFMarketJobFinderNavIcon,
  SFAllJobsNavIcon,
} from "@sf-core";
import { Claims } from "../../constants/claims";

const getNavDefs = ({
  t, // i18n translation function
}) => {
  return [
    {
      path: PATHS.BENCHMARK_SKILLS_PATH,
      permissions: [Claims.AdminBenchmarkSkillsView],
      icon: <SFAllJobsNavIcon />,
      header: t("benchmark.titles.benchmarkSkills"),
      description: t("benchmark.titles.benchmarkSkills"),
      default: true,
    },
    {
      path: PATHS.BENCHMARK_MICROSKILLS_PATH,
      permissions: [Claims.AdminBenchmarkMicroSkillsView],
      icon: <SFByBusinessCapabilityNavIcon />,
      header: t("benchmark.titles.benchmarkMicroSkills"),
      description: t("benchmark.titles.benchmarkMicroSkills"),
    },
    {
      path: PATHS.BENCHMARK_JFA_PATH,
      permissions: [Claims.AdminBenchmarkJFAView],
      icon: <SFMarketJobFinderNavIcon />,
      header: t("benchmark.titles.benchmarkJFA"),
      description: t("benchmark.titles.benchmarkJFA"),
    },
  ];
};

export default getNavDefs;
